export enum ECampaignRoutes {
  CAMPAIGN_SUBMISSIONS = '/jobs/:id/submissions',
  CAMPAIGN_SUBMISSION_DETAIL = '/jobs/:campaignId/submissions/:submissionId',
  PREVIEW_CAMPAIGN = '/jobs/summary/preview',
  CAMPAIGN_DETAIL = '/jobs/:campaignId',
  CAMPAIGN_MY_JOBS = '/jobs',
  CREATE_CAMPAIGN = '/jobs/create',

  CAMPAIGNS_PUBLIC_PREFIX = '/public-jobs',
  CAMPAIGNS_PUBLIC = '/public-jobs/:hashId',
  CAMPAIGNS_PUBLIC_SUBMISSIONS = '/public-jobs/:hashId/submissions',

  CAMPAIGNS_PUBLIC_ONBOARDING = '/onboarding',
  CAMPAIGNS_PUBLIC_ONBOARDING_SUBMISSIONS = '/onboarding/submissions',

  CAMPAIGNS_APPLICANTS = '/jobs/:campaignId/applicants'
}
